module.exports = __webpack_public_path__ + "img/aboutus_qiyewenhua.d0fda04a.png";